// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i5ohdNZYaQxf3NEPjLr4{padding-left:24px;padding-right:24px;flex-direction:column;gap:24px;padding-bottom:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `i5ohdNZYaQxf3NEPjLr4`
};
export default ___CSS_LOADER_EXPORT___;
